<template>
  <div class="qr-container">
    <qrcode-vue v-if="uuid" :value="url" :size="size" level="H" />
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
    data() {
        return {
            value: `${process.env.VUE_APP_SITE_URL}/register/card-details`,
            size: 300,
        };
    },
    components: {
        QrcodeVue,
    },

    computed: {
        uuid() {
            return this.$store.getters['register/getIncompleteRegistrantUuid'];
        },
        url() {
            return `${this.value}?uuid=${this.uuid}`;
        },
    },
};
</script>

<style scoped>
  .qr-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
